// extracted by mini-css-extract-plugin
module.exports = {"hero":"Hero--hero--3mXx1","items":"Hero--items--6ZdnB","hasSubLinks":"Hero--hasSubLinks--6JlIU","subItems":"Hero--subItems--2XiVN"};